import { Row, Col, Button } from "react-bootstrap";
import { Link } from 'react-router-dom';

import styles from "./VoteProposalSection.module.css";

function VoteProposalSection() {
    return (
        <Row className={styles.ContentContainer}>
            <Col className="d-flex align-items-center">
                <div>
                    <div className={styles.makeProposalTitle}>Vote for The Latest Proposals</div>
                    <div className={styles.makeProposalSubtext}>Stay connected to see the latest project proposals for businesses and social causes, and contribute your opinion to support them. Your feedback and contribution can help them acquire starter capital, and drive a purpose that helps the community.</div>

                    <Link to="/">
                        <Button className={styles.makeProposalButtons}>
                            <div className={styles.makeProposalButtonText}>Vote</div>
                        </Button>
                    </Link>
                </div>
            </Col>
        </Row>
    );
}

export default VoteProposalSection;